























































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { AxiosError } from 'axios';

import { ErrorManager, IOrder } from '@/models';

import ALPage from '@/components/core/Page/ALPage.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

export default Vue.extend({
  name: 'OrderDetailPage',

  components: { ALPage, ErrorAlert },

  data: () => ({
    loading: true,
    order: null as IOrder | null,
    orderLines: [],
    search: '',
    headers: [
      {
        text: 'Part Num.',
        align: 'start',
        value: 'part_num'
      },
      {
        text: 'Description',
        align: 'start',
        value: 'description'
      },
      { text: 'Quantity', align: 'end', width: 100, value: 'quantity' },
      { text: 'Unit price', align: 'end', value: 'unit_price' },
      { text: 'Amount', align: 'end', value: 'amount' }
    ],

    errorMessage: '',
    detailErrorMessage: ''
  }),
  computed: {
    ...mapGetters({
      getOrderBySeries: 'order/getOrderBySeries'
    }),

    seriesId(): string {
      return this.$route.params.series;
    }
  },
  methods: {
    ...mapActions({
      fetchOrder: 'order/fetchOrder'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    getOrderLines() {
      this.clearAllErrors();
      return this.$axios({
        method: 'get',
        url: `/v1/orders/${this.seriesId}/lines/`,
        timeout: 10 * (60 * 1000)
      }).then(({ data }) => data);
    },

    async tryGetOrFetchOrder(series: string): Promise<IOrder> {
      if (!this.getOrderBySeries(series)) {
        await this.fetchOrder(series);
      }
      return this.getOrderBySeries(series);
    }
  },
  async mounted() {
    this.loading = true;

    try {
      this.order = await this.tryGetOrFetchOrder(this.seriesId);
      this.orderLines = await this.getOrderLines();
    } catch (err) {
      const error = err as AxiosError;
      this.errorMessage = ErrorManager.extractApiError(error);
      if (error.response) {
        if (error.response.data.detail) {
          this.detailErrorMessage = error.response.data.detail;
        }
      }
    } finally {
      this.loading = false;
    }
  }
});
